import { CreatePreCheckout, PreCheckoutDetails } from 'interfaces/event';
import * as Rx from 'rxjs';
import * as RxOp from 'rxjs-operators';

import apiService, { ApiService } from 'services/api';
import { Products } from 'interfaces/event';

type GetSunUrlParams = {
  buy: Products[];
  cart_id: string;
};

export class PreCheckoutService {
  constructor(private apiService: ApiService) {
    this.apiService = apiService;
  }

  public details(eventId: string, transactionKey: string): Rx.Observable<PreCheckoutDetails> {
    return this.apiService
      .get(`/event_services/reserve/${transactionKey}/${eventId}`)
      .pipe(RxOp.map(response => response.data));
  }

  public create(params: CreatePreCheckout): Rx.Observable<any> {
    return this.apiService.post('precheckout/create', params).pipe(RxOp.map(response => response.data));
  }

  public getSunUrl(params: GetSunUrlParams): Rx.Observable<any> {
    return this.apiService.post('event_services/buy', params).pipe(RxOp.map(response => response.data[0]));
  }
}

const preCheckoutService = new PreCheckoutService(apiService);

export default preCheckoutService;
